import { autoinject } from "aurelia-dependency-injection";
import Marionette from "../../shared/marionette-mustache";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import { OverviewReelView } from "./overview-reel";
import { OverviewReelModel } from "../models/overview-reel";
import { ReelItemModel } from "../models/reel-item";
import { WelcomeModel } from "../../search/models/welcome";
import { WelcomeListItemModel } from "../../search/models/welcome-list-item";
import { IRequestOptions } from "../../search/interfaces/request-options";
import { AppEvents } from "../../app-events";
import { AppSettings } from "../../app-settings";
import { OverviewSearchReelModel } from "../models/overview-search-reel";
import { OverviewReelsView } from "./overview-reels";
import { OverviewResourceReelModel } from "../models/overview-resource-reel";
import { OverviewDocumentReelModel } from "../models/overview-document-reel";
import { OverviewProductReelModel } from "../models/overview-product-reel";

const template = require<string>("./overview.html");

const dom = {
    DOCUMENT_REEL_REGION: "#overview-document-reel-region",
    SEARCH_REEL_REGION: "#overview-search-reel-region",
    RESOURCE_REEL_REGION: "#overview-resource-reel-region"
};

@backboneViewProperties({
    template: template
})
export class OverviewView extends Marionette.LayoutView<WelcomeModel> {

    public template: string;
    private reelsRegion: Marionette.Region;
    private reelsView: OverviewReelsView;
    private reelsCollection: Backbone.Collection<OverviewReelModel>;

    constructor(private appEvents: Backbone.Events) {
        super();
        this.reelsCollection = new Backbone.Collection<OverviewReelModel>();
        this.setupSubViews();
    }

    public onShow() {
       this.reelsView = new OverviewReelsView({collection: this.reelsCollection});
       this.reelsRegion.show(this.reelsView);
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {
            "click .search-link": (e) => this.searchLinkClick(e)
        };
        return events;
    }

    public regions(): any {
        return {
            reelsRegion: "#reels-region"
        };
    }

    private setupSubViews() {
        this.setupSearchReelView();
        this.setupDocumentReelView();
        // this.setupProductReelView(); //  Not ready yet
        this.setupResourceReelView();
    }

    private setupDocumentReelView() {
        const documentReelModel = new OverviewDocumentReelModel();
        this.reelsCollection.add(documentReelModel);
    }

    private setupSearchReelView() {
        const searchReelModel = new OverviewSearchReelModel();
        this.reelsCollection.add(searchReelModel);
    }

    private setupProductReelView() {
        const productReelModel = new OverviewProductReelModel();
        this.reelsCollection.add(productReelModel);
    }

    private setupResourceReelView() {
        const resourceReelModel = new OverviewResourceReelModel();
        this.reelsCollection.add(resourceReelModel);
    }

    private searchLinkClick(e: JQueryMouseEventObject) {
        e.stopPropagation();
        const query = $(e.currentTarget).attr("data-query");
        const model = this.model.RecentSearches.where({ Query: query })[0];
        this.appEvents.trigger(AppEvents.SearchRequest, model.Options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/overview.ts